var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 343,
    viewBox: "0 0 224 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.44 -62.1874C196.783 -62.7222 199.217 -62.7222 201.56 -62.1874L282.518 -43.7093C284.861 -43.1744 287.054 -42.1184 288.934 -40.6198L353.857 11.1547C355.736 12.6533 357.253 14.5562 358.296 16.7218L394.326 91.538C395.369 93.7037 395.91 96.0764 395.91 98.4801V181.52C395.91 183.924 395.369 186.296 394.326 188.462L358.296 263.278C357.253 265.444 355.736 267.347 353.857 268.845L288.934 320.62C287.054 322.118 284.861 323.174 282.518 323.709L201.56 342.187C199.217 342.722 196.783 342.722 194.44 342.187L113.482 323.709C111.139 323.174 108.946 322.118 107.066 320.62L42.1434 268.845C40.2641 267.347 38.7466 265.444 37.7037 263.278L1.67413 188.462C0.631206 186.296 0.0896301 183.924 0.0896301 181.52V98.4801C0.0896301 96.0764 0.631207 93.7037 1.67413 91.538L37.7037 16.7218C38.7466 14.5562 40.2641 12.6533 42.1434 11.1547L107.066 -40.6198C108.946 -42.1184 111.139 -43.1744 113.482 -43.7093L194.44 -62.1874Z",
    fill: "#FFD645"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPolygon);
export default __webpack_public_path__ + "static/media/yellowPolygon.c106d438f5e3e1159daf66b33db66923.svg";
export { ForwardRef as ReactComponent };